module.exports = __webpack_public_path__ + "static/media/Ubuntu_Desktop.1b640335.svg";